"use strict";
import _ from 'lodash';

export default class SendMessageController
{
	/*@ngInject*/
	constructor($http, $scope, $stateParams, $state, messageService)
	{
		if (_.isNil($stateParams.id))
			return $state.go("myevents");

		this.$http = $http;
		this.$state = $state;
		this.eventId = $stateParams.id;
		this.messageService = messageService;

		$http.post('/api/backend/events/' + $stateParams.id)
		.then(response =>
		{
			//console.log(response.data);
			this.title = "Mensaje desde Everlaps: " + response.data.title; 
		}); 
	}

	SendMessage()
	{
		this.$http.post("/api/backend/events/sendmessage/" + this.eventId, {html: this.descriptionhtml})
		.then(response =>
		{
			this.messageService.Success("Mensaje enviado");
			this.$state.go("myevents");
		});
	}
}


// WEBPACK FOOTER //
// ./client/app/backend/events/send_message.controller.js